import { route } from '@/utils/build'
import { appUser } from '@/utils/auth'
const component = path => resolve => require(['@/pages/payment/views/' + path], resolve)
// ios审核号
const isAudit = appUser.buildVersion === '20092709'

/**
 * 注册全局路由
 */
export default [
  // 商品
  route('/goods', 'goods', component('goods/goods'), { isAudit }),
  route('/goods-physical', 'goods-physical', component('goods/goods-physical'), { isAudit }),
  route('/goods-physical-detail', 'goods-physical-detail', component('goods/goods-physical-detail'), { isAudit }),
  route('/goods-discount-list', 'goods-discount-list', component('goods/goods-discount-list')),
  // 专清计划的商品
  route('/goods-studyplan', 'goods-studyplan', component('goods/goods-studyplan/studyplan')),
  route('/goods-studyplan-order/:id', 'goods-studyplanorder', component('goods/goods-studyplan/studyplan-order')),
  route(
    '/goods-studyplan-success/:id',
    'goods-studyplanorder-success',
    component('goods/goods-studyplan/studyplan-success')
  ),

  // VIP卡片
  route('/vip', 'vip', resolve => require(['@/pages/payment/views/goods/vip/index'], resolve), { isAudit }),
  // 激活码
  route('/activation', 'activation', resolve => require(['@/pages/payment/views/goods/activation'], resolve)),
  route('/activationAdviser', 'activationAdviser', resolve =>
    require(['@/pages/payment/views/goods/activationAdviser'], resolve)
  ),

  // 礼品卡页面
  route('/gift-card', 'gift-card', resolve => require(['@/pages/payment/views/goods/gift-card'], resolve)),
  // 礼品卡领取成功跳转
  route('/giftcard-success', 'giftcard-success', resolve =>
    require(['@/pages/payment/views/goods/giftcard-success'], resolve)
  ),
  // 礼品卡消息
  route('/message', 'message', resolve => require(['@/pages/payment/views/goods/message'], resolve)),

  /** 活动相关 */

  // 单向历上的二维码扫码页面
  route('/dxl', 'dxl', resolve => require(['@/pages/payment/views/goods/activity/jumpto-dxl'], resolve)),
  // 《10.23 单向街合作活动》
  route('/goods_freeget', 'goods_freeget', resolve =>
    require(['@/pages/payment/views/goods/activity/goods_freeget'], resolve)
  ),
  // 《2.14 情人节活动》
  route('/goods_lover', 'goods_lover', resolve =>
    require(['@/pages/payment/views/goods/activity/goods_lover'], resolve)
  ),
  // 《学生认证活动》
  route('/student_certification', 'student_certification', resolve =>
    require(['@/pages/payment/views/goods/activity/student_certification'], resolve)
  ),
  // 用户协议
  route('/miniAppAgreement', 'miniAppAgreement', resolve =>
    require(['@/pages/payment/views/goods/activity/miniAppAgreement'], resolve)
  ),
  // 《学生认证活动/认证页面》
  route('/certification', 'certification', resolve =>
    require(['@/pages/payment/views/goods/activity/certification'], resolve)
  ),
  // 《1108 无限卡》历史订单
  route('/goods/order-list', 'goods-order-list', resolve =>
    require(['@/pages/payment/views/goods/components/goods-detail/goods-order-list'], resolve)
  ),
  // 《1108 无限卡》历史订单
  route('/goods/full-course', 'full-course', resolve =>
    require(['@/pages/payment/views/goods/components/goods-detail/full-course'], resolve)
  ),
  // 《1108 无限卡》协议
  route('/goods/vip-forever-protocol', 'goods-vip-forever-protocol', resolve =>
    require(['@/pages/payment/views/goods/components/goods-detail/goods-vip-forever-protocol'], resolve)
  ),
  // 《1108 无限卡》2021协议 >>>>>> 2022年06月14日 更新无限卡增订版协议
  route('/goods/vip-forever-protocol2022', 'goods-vip-forever-protocol2022', resolve =>
    require(['@/pages/payment/views/goods/components/goods-detail/goods-vip-forever-protocol2022'], resolve)
  ),
  // 《618 无限卡》2023协议
  route('/goods/vip-forever-protocol2023', 'goods-vip-forever-protocol2023', resolve =>
    require(['@/pages/payment/views/goods/components/goods-detail/goods-vip-forever-protocol2023'], resolve)
  ), // 1108 无限卡》2023协议
  route('/goods/vip-forever-protocol2023', 'goods-vip-forever-protocol20231108', resolve =>
    require(['@/pages/payment/views/goods/components/goods-detail/goods-vip-forever-protocol20231108'], resolve)
  ),
  //2024 618 无限卡》2023协议
  route('/goods/goods-vip-forever-protocol2024618', 'goods-vip-forever-protocol2024618', resolve =>
    require(['@/pages/payment/views/goods/components/goods-detail/goods-vip-forever-protocol2024618'], resolve)
  ),
  // 实物商品
  route('/goods/goods-merchandise', 'goods-merchandise', resolve =>
    require(['@/pages/payment/views/goods/components/goods-detail/goods-merchandise'], resolve)
  ),

  // 外刊年卡协议
  route('/goods/goods-vip-foreign-protocol', 'goods-vip-foreign-protocol', resolve =>
    require(['@/pages/payment/views/goods/components/goods-detail/goods-vip-foreign-protocol'], resolve)
  ),
  // 全站卡协议 - 在2022-01-15 日改成 友邻少年畅听卡套餐协议
  route('/goods/goods-vip-all-protocol', 'goods-vip-all-protocol', resolve =>
    require(['@/pages/payment/views/goods/components/goods-detail/goods-vip-all-protocol'], resolve)
  ),
  route('/goods/goods-vip-all-protocol-2024', 'goods-vip-all-protocol-2024', resolve =>
    require(['@/pages/payment/views/goods/components/goods-detail/goods-vip-all-protocol-2024'], resolve)
  ),
  route('/goods/goods-vip', 'goods-vip', resolve =>
    require(['@/pages/payment/views/goods/components/goods-detail/goods-vip'], resolve)
  ),
  // 获取训练营的商品链接
  route('/goods/goods-camp', 'goods-camp', resolve =>
    require(['@/pages/payment/views/goods/goods-camp/goods-camp'], resolve)
  ),
  // 2022年05月17日  内容团队成员介绍详情---嵌套APP使用
  route('/goods/courseInfo', 'courseInfo', resolve => require(['@/pages/payment/views/courseInfo'], resolve))
]
